module.exports = new __parcel__URL__("neon_gold_pack_reward.fb1eea7c.png").toString();